import React from 'react';
import { useTreeCard } from '../TreeCard';

interface IButtonProps {
  seeMoreLabel: string;
  seeLessLabel: string;
  dataTestId?: string;
}

export const Button: React.FC<IButtonProps> = ({
  seeMoreLabel,
  seeLessLabel,
  dataTestId = '',
}) => {
  const { isExpanded, setIsExpanded } = useTreeCard();
  const label = isExpanded ? seeLessLabel : seeMoreLabel;

  return (
    <button
      aria-label={label}
      className="tw-lf-button tw-lf-button-ghost tw-lf-button-md"
      onClick={() => setIsExpanded(!isExpanded)}
      data-testid={dataTestId}
    >
      {label}
    </button>
  );
};
